class Tabs extends HTMLElement {
  constructor() {
    super();

    this.tabHeaders = this.querySelectorAll("tab-header");
    this.tabDetails = this.querySelectorAll("tab-details");

    // Get the current product handle from the URL
    const currentProductHandle = window.location.pathname.split("/").pop();

    let defaultTabIndex = 0; // Index for the first tab as default
    this.tabDetails.forEach((details, index) => {
      const productLinks = details.querySelectorAll(".flavour_opiton-item");
      productLinks.forEach((link) => {
        const productHandle = link.getAttribute("data-handle");

        // If product handle matches, set this tab as the default open tab
        if (productHandle === currentProductHandle) {
          defaultTabIndex = index;
        }
      });
    });

    // Set the tabs, with the default or matched one opened
    this.tabHeaders.forEach((header, index) => {
      header.addEventListener("click", this.onHeaderClick.bind(this));
      if (index === defaultTabIndex) {
        header.setAttribute("aria-selected", "true");
        this.tabDetails[index].setAttribute("aria-hidden", "false");
      } else {
        header.setAttribute("aria-selected", "false");
        this.tabDetails[index].setAttribute("aria-hidden", "true");
      }
    });
  }

  onHeaderClick(event) {
    const header = event.target.closest("tab-header");
    const tabIndex = Array.from(this.tabHeaders).indexOf(header);
    const tabDetails = this.tabDetails[tabIndex];

    // Deselect all tabs and hide all details
    this.tabHeaders.forEach((header, index) => {
      header.setAttribute("aria-selected", index === tabIndex);
    });

    this.tabDetails.forEach((details, index) => {
      details.setAttribute("aria-hidden", index !== tabIndex);
    });
  }
}

customElements.define("custom-tabs", Tabs);
